<script>
  let recurring = false;
  export let itemData = [];
  export let selectedItem = [];
  export let childKey;
  import { createEventDispatcher } from 'svelte';
  import { searchKeyByValue, cloneArray } from 'components/Helper.js';
  export let comeFrom = '';
  let selectAll = comeFrom == 'client' ? false : true;
  const dispatch = createEventDispatcher();
  // let itemSelected=selectedItem.length==0?cloneArray(itemData):cloneArray(selectedItem);
  const selectAllItems = () => {
    if (selectedItem.length == 0) {
      return cloneArray(itemData);
    } else {
      selectAll = false;
      return cloneArray(selectedItem);
    }
  };
  let itemSelected = comeFrom == 'client' ? selectedItem : selectAllItems();
  const checkChildChecked = (parentId, childId) => {
    let parentKey = searchKeyByValue(itemSelected, 'id', parentId);
    if (
      parentKey != -1 &&
      searchKeyByValue(itemSelected[parentKey][childKey], 'id', childId) !== -1
    ) {
      return true;
    }
    return false;
  };

  // $: itemSelected && selectAllItems();

  let showData = true;
</script>

{#if itemData.length == 0}
  <li class="category-list">No filter found</li>
{/if}
<div class="checkbox c-checkbox">
  <label class="text-nowrapp">
    <input
      type="checkbox"
      checked={selectAll}
      on:change={(event) => {
        showData = false;
        if (event.target.checked) {
          selectAll = true;
          itemSelected = cloneArray(itemData);
          dispatch('onSelect', itemSelected);
        } else {
          selectAll = false;
          itemSelected = [];
          dispatch('onSelect', itemSelected);
        }
        setTimeout(() => {
          showData = true;
        });
      }}
      value="1"
    />
    <span class="check-img"></span>
    {#if selectAll}
      Unselect All
    {:else}Select All
    {/if}
  </label>
</div>
{#if showData}
  {#each itemData as item}
    <li class="category-list">
      <div class="checkbox c-checkbox">
        <label class="text-nowrapp">
          <input
            type="checkbox"
            checked={searchKeyByValue(itemSelected, 'id', item.id) !== -1}
            on:change={(event) => {
              let oldItemSelected = [...itemSelected];
              if (event.target.checked) {
                var params = { id: item.id, name: item.name };
                params[childKey] = [];
                oldItemSelected.push(params);
              } else {
                oldItemSelected.splice(searchKeyByValue(oldItemSelected, 'id', item.id), 1);
                selectAll = false;
              }
              itemSelected = oldItemSelected;
              dispatch('onSelect', itemSelected);
            }}
            value="1"
          />
          <span class="check-img"></span>
          {item.name}
        </label>
      </div>

      {#if childKey != undefined && item[childKey] != undefined && item[childKey].length > 0 && searchKeyByValue(itemSelected, 'id', item.id) !== -1}
        <ul>
          {#each item[childKey] as childItem}
            <li>
              <div class="checkbox c-checkbox">
                <label class="text-nowrapp">
                  <input
                    type="checkbox"
                    checked={checkChildChecked(item.id, childItem.id)}
                    on:change={(event) => {
                      let oldItemSelected = [...itemSelected];
                      let parentKey = searchKeyByValue(oldItemSelected, 'id', item.id);
                      if (parentKey == -1) {
                        var params = {
                          id: item.id,
                          name: item.name,
                        };
                        params[childKey] = [];
                        oldItemSelected.push(params);
                        parentKey = oldItemSelected.length - 1;
                      }
                      if (event.target.checked) {
                        oldItemSelected[parentKey][childKey].push(childItem);
                      } else {
                        oldItemSelected[parentKey][childKey].splice(
                          searchKeyByValue(
                            oldItemSelected[parentKey][childKey],
                            'id',
                            childItem.id,
                          ),
                          1,
                        );
                        selectAll = false;
                      }
                      itemSelected = oldItemSelected;
                      dispatch('onSelect', itemSelected);
                    }}
                  />
                  <span class="check-img"></span>
                  {childItem.name}
                </label>
              </div>
            </li>
          {/each}
        </ul>
      {/if}
    </li>
  {/each}
{/if}

<style lang="scss">
  .category-list {
    margin-top: 4px;
    margin-bottom: 4px;

    ul {
      list-style: none;
      margin: 10px 0 10px 0px;

      li {
        padding: 4px 0;
      }
    }
  }
</style>
